import React from 'react';
import './index.scss';

const Branding = () => {
  return <div className="branding-bar">
      <div className="branding-container">
        <img className="branding-img-left" src="https://webinars.f-integra.org/webinars/images/Logo.png" alt="Webinars"/>
        <img className="branding-img-right" src="https://webinars.f-integra.org/webinars/images/Logo-UE.png" alt="Unión Europea"/>
      </div>
  </div>
};

// Avoid re-render
const areEqual = () => true;

export default React.memo(Branding, areEqual);


